import { render, staticRenderFns } from "./Demo.vue?vue&type=template&id=0c80b05a&scoped=true&"
import script from "./Demo.vue?vue&type=script&lang=js&"
export * from "./Demo.vue?vue&type=script&lang=js&"
import style0 from "./Demo.vue?vue&type=style&index=0&id=0c80b05a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c80b05a",
  null
  
)

export default component.exports